(function () {
  'use strict';

  var SIDEBAR_SELECTOR = '[data-tp-quick-cart]';
  var STYLE_ID = 'tp-quick-cart-ux-fix-styles';

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .halo-cart-sidebar[data-tp-quick-cart] {
        display: flex !important;
        flex-direction: column !important;
        overflow: hidden !important;
      }

      .halo-cart-sidebar[data-tp-quick-cart] .halo-sidebar-header {
        flex: 0 0 auto !important;
      }

      .halo-cart-sidebar[data-tp-quick-cart] .halo-sidebar-wrapper {
        display: flex !important;
        flex: 1 1 auto !important;
        flex-direction: column !important;
        min-height: 0 !important;
        max-height: none !important;
        overflow: hidden !important;
        overscroll-behavior: none !important;
      }

      .halo-cart-sidebar[data-tp-quick-cart] .previewCartMessage.tp-cart-shipping {
        flex: 0 0 auto !important;
      }

      .halo-cart-sidebar[data-tp-quick-cart] cart-coupon-discount[data-is-sidebar="true"] {
        display: flex !important;
        flex: 1 1 auto !important;
        flex-direction: column !important;
        min-height: 0 !important;
        overflow: hidden !important;
      }

      .halo-cart-sidebar[data-tp-quick-cart] .previewCart-wrapper {
        display: flex !important;
        flex: 1 1 auto !important;
        flex-direction: column !important;
        min-height: 0 !important;
        overflow: hidden !important;
      }

      .halo-cart-sidebar[data-tp-quick-cart] .previewCart {
        flex: 1 1 auto !important;
        min-height: 0 !important;
        max-height: none !important;
        overflow-x: hidden !important;
        overflow-y: auto !important;
        overscroll-behavior-y: contain !important;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: thin;
        scrollbar-color: rgba(60,51,46,.24) transparent;
      }

      .halo-cart-sidebar[data-tp-quick-cart] .previewCart::-webkit-scrollbar {
        width: 4px;
      }

      .halo-cart-sidebar[data-tp-quick-cart] .previewCart::-webkit-scrollbar-thumb {
        background: rgba(60,51,46,.20);
      }

      .halo-cart-sidebar[data-tp-quick-cart] .previewCartInfo {
        position: relative !important;
        inset: auto !important;
        bottom: auto !important;
        flex: 0 0 auto !important;
      }

      .halo-cart-sidebar[data-tp-quick-cart] .previewCartTool,
      .halo-cart-sidebar[data-tp-quick-cart] .popup-toolDowns {
        flex: 0 0 auto !important;
      }

      .halo-cart-sidebar[data-tp-quick-cart] .tp-cart-shipping .progress-truck-wrapper {
        width: 25px !important;
        height: 25px !important;
        display: grid !important;
        place-items: center !important;
        padding: 0 !important;
        border: 1px solid rgba(177,100,63,.30) !important;
        border-radius: 50% !important;
        background: #FBF7F0 !important;
        color: #B1643F !important;
        box-shadow: 0 2px 8px rgba(60,51,46,.08) !important;
      }

      .halo-cart-sidebar[data-tp-quick-cart] .tp-cart-shipping .progress-truck-wrapper .icon-shipping-truck {
        display: none !important;
      }

      .halo-cart-sidebar[data-tp-quick-cart] .tp-cart-shipping__progress-icon {
        width: 14px !important;
        height: 14px !important;
        display: block !important;
        overflow: visible;
      }
    `;
    document.head.appendChild(style);
  }

  function replaceShippingIcon(sidebar) {
    var wrapper = sidebar.querySelector('.tp-cart-shipping .progress-truck-wrapper');
    if (!wrapper || wrapper.dataset.tpShippingIcon === 'parcel') return;

    wrapper.dataset.tpShippingIcon = 'parcel';
    wrapper.innerHTML =
      '<svg class="tp-cart-shipping__progress-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
        '<path d="M4.5 7.4 12 3.25l7.5 4.15v9.2L12 20.75l-7.5-4.15V7.4Z" fill="none" stroke="currentColor" stroke-width="1.45" stroke-linejoin="round"/>' +
        '<path d="m4.8 7.65 7.2 3.95 7.2-3.95M12 11.6v8.6" fill="none" stroke="currentColor" stroke-width="1.45" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';
  }

  function enhance(sidebar) {
    if (!sidebar) return;
    ensureStyles();
    replaceShippingIcon(sidebar);
  }

  function initSidebar(sidebar) {
    if (!sidebar) return;
    enhance(sidebar);

    if (sidebar.dataset.tpQuickCartUxFixReady === 'true') return;
    sidebar.dataset.tpQuickCartUxFixReady = 'true';

    var observer = new MutationObserver(function () {
      enhance(sidebar);
    });

    observer.observe(sidebar, {
      childList: true,
      subtree: true
    });
  }

  function init(root) {
    ensureStyles();
    var scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches(SIDEBAR_SELECTOR)) {
      initSidebar(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll(SIDEBAR_SELECTOR).forEach(initSidebar);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
